class SideBar extends HTMLElement {
  constructor() {
    super();
    this.sideBarItems = this.querySelectorAll('[data-side-bar-item]');
    this.progressStep = 100 / this.sideBarItems.length;
    this.sideBarProgress = this.querySelector('[data-side-bar-progress]');
    // check if the section is in the viewport
    this.checkSideBarItems();

    this.sideBarItems.forEach((item) => {
      item.addEventListener('click', () => this.checkSideBarItems());
    });

    // on page scroll, check if the section is in the viewport
    window.addEventListener('scroll', () => this.checkSideBarItems());
  }

  /**
   * checkSideBarItems
   * @description Check if the section is in the viewport and add the active class to the item
   */
  checkSideBarItems() {
    this.sideBarItems.forEach((item) => {
      item.classList.remove('active');
      let isInViewport = false;
      let isOutViewport = true;
      const id = item
        .querySelector('[data-side-bar-item-link]')
        .getAttribute('href')
        .replace('#', '');
      const section = document.getElementById(id);

      if (section) {
        // get the middle of the section
        const sectionMiddle = section.offsetTop + section.offsetHeight / 3;
        const sectionBottom = section.offsetTop + section.offsetHeight / 2;

        isInViewport = sectionMiddle < window.scrollY + window.innerHeight;
        isOutViewport = sectionBottom < window.scrollY;

        if (isOutViewport) {
          item.classList.remove('active');
        } else if (isInViewport) {
          const itemIndex = Array.from(this.sideBarItems).indexOf(item);
          item.classList.add('active');
          this.sideBarProgress.style.top = `${itemIndex * this.progressStep}%`;
        } else {
          item.classList.remove('active');
        }
      }
    });
  }
}

customElements.define('side-bar', SideBar);
